module.exports = __webpack_public_path__ + "account/assets/email.355cc0e2.svg";